// sets the page's <title> attribute on each render

type PageTitleProps = { title: string }
export default ({ title }: PageTitleProps) => {
  document.title = `Billing Hub - ${title}`
  return null
}
